<template>
  <div class="w3-main main-container">
    <page-header />

    <about-content />
  </div>
</template>

<script>
  import PageHeader from '@/components/PageHeader';
  import AboutContent from '@/components/AboutContent';

  export default {
    name: 'about',
    created() {
      document.title = 'Rólunk | BeCreative';
    },
    mounted() {
      scrollTo(0, 0);
    },
    computed: {
      locale() {
        return this.$store.state.i18n.locale;
      },
    },
    components: {
      PageHeader,
      AboutContent,
    },
  };

</script>


<style scoped>
 </style>



// WEBPACK FOOTER //
// About.vue?a9748ed4